import consts from "@/consts"
import {getApiProps} from "@/lib/lib";
import range from "lodash/range";
// import {objectComparison} from "@/lib/lib";
const with_removed = String(process.env.VUE_APP_PACKAGE).includes('admin') ? {'force[with_removed]': 1} : {}
const changedField = 'changed_at';

const collator = new Intl.Collator();
const sortByName = function (a, b) {
    let cmp = collator.compare(a?.name_ || '', b?.name_ || '')
    if (cmp) {
        return cmp;
    }
    return a.id - b.id;
}

let _servicesIndexCache = {arr: null, map: null}
function getServicesIndexMap(state) {
    if (_servicesIndexCache.arr !== state.services) {
        _servicesIndexCache.map = new Map(state.services.map((u, i) => [u.id, i]))
        _servicesIndexCache.arr = state.services
    }
    return _servicesIndexCache.map
}

export default {
    state: {
        servicesLiteLoad: false,
        servicesFullLoad: false,
        services: [],
    },
    actions: {
        fetchServices/*all*/({dispatch, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchServices', args, time: Date.now() / 1000})

                const params = getApiProps('services', args)
                this.$api.services.getAll({...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            resolve(response.data)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchServices', args, inprogress: false})
                    });
            })
        },
        fetchServicesAll({dispatch, commit}) {
            new Promise((resolve, reject) => {
                this.$api.init.getServices()
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {

                            commit('setServices', response.data)
                            commit('setServicesLiteLoad', true)

                            resolve(true)
                        } else {
                            reject(response)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchServicesAll', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchServicesAllLite({dispatch, commit, getters}) {
            return new Promise((resolve, reject) => {
                if (getters.isServicesLiteLoad) {
                    return resolve(getters.getServices.length)
                }
                dispatch('fetchServices', {lite: true})
                    .then((data) => {
                        commit('updateServices', data)
                        //commit('setServicesLiteLoad', true)
                        resolve(data.length)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                        setTimeout(() => {
                            dispatch('fetchServicesAllLite', {})
                        }, 60 * 1000)
                    })
            })
        },
        fetchServicesAllPages({dispatch, commit, getters}, args) {
            //dispatch('setLastCall', {name: 'fetchServicesAll', args, time: Date.now() / 1000})
            dispatch('setLastCall', {name: 'fetchServicesChanged', args, time: Date.now() / 1000})

            return new Promise((resolve, reject) => {
                    if (!getters.getApiToken) {
                        return reject(null)
                    }
                    if (!getters.getServices.length) {
                        return resolve([])
                    }
                    let pageSize = consts.querySettings.pageSize
                    let pages = Math.ceil(getters.getServices.length / pageSize)
                    let fetch = range(pages).map(i => {
                        let page = i + 1;
                        return dispatch('fetchServices', {page, 'page-size': pageSize, ...args})
                            .then((data) => {
                                commit('updateServices', data)
                            })
                            .catch(() => {
                                dispatch('fetchServices', {page, 'page-size': pageSize, ...args})
                            })
                    });
                    resolve(fetch)
                })
                .then((fetch) => {
                    return Promise.all(fetch)
                        .finally(() => {
                            commit('setServicesFullLoad', true)
                        })
                })
                .finally(() => {
                    //dispatch('setLastCall', {name: 'fetchServicesAll', args, inprogress: false})
                    dispatch('setLastCall', {name: 'fetchServicesChanged', args, inprogress: false})
                })
        },
        fetchServicesChanged({dispatch, commit, getters}, args) {
            if (!getters.getApiToken || !getters.isServicesFullLoad) {
                return Promise.resolve(null)
            }

            dispatch('setLastCall', {name: 'fetchServicesChanged', args, time: Date.now() / 1000})

            args = {...consts.querySettings.filter, ...args}
            return dispatch('fetchServices', args)
                .then((data) => {
                    commit('updateServices', data)
                    return dispatch('fetchServices', {fields: 'id', expand: ''})
                })
                .then((data) => {
                    commit('filterServices', data)
                })
                .finally(() => {
                    dispatch('setLastCall', {name: 'fetchServicesChanged', args, inprogress: false})
                });
        },
        fetchFavoritesServices({dispatch, commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken) {
                    return reject(false)
                }

                dispatch('setLastCall', {name: 'fetchFavoritesServices', args, time: Date.now() / 1000})

                dispatch('fetchServices', {filter: {favorites: true}})
                    .then((data) => {
                        commit('updateServices', data)
                        resolve(true)
                    })
                    .catch((error) => {
                        reject(error)
                        console.error(error);
                    })
                    .finally(() => {
                        dispatch('setLastCall', {name: 'fetchFavoritesServices', args, inprogress: false})
                    });
            })
        },
        reloadServicesAll({commit, dispatch}, args) {
            commit('clearServices')
            return dispatch('fetchServicesAllLite', args)
                .then(() => {
                    dispatch('fetchServicesAllPages', args)
                })
        },

        fetchService({commit, getters}, args) {
            return new Promise((resolve, reject) => {
                if (!getters.getApiToken || !args.id) {
                    return reject(false)
                }
                const params = getApiProps('services', args)
                delete params.id;
                this.$api.services.find(args.id, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateService', response.data)
                            resolve(true)
                        } else {
                            console.error(response);
                            reject(false)
                        }
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(false)
                    });
            });
        },

        saveService({dispatch}, service) {
            let fn = (service.id) ? 'updateService' : 'createService'
            return dispatch(fn, service);
        },
        createService({commit, dispatch}, service) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('services')
                this.$api.services.create(service, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateService', response.data)
                            dispatch('fetchServicesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        updateService({commit, dispatch}, service) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('services')
                this.$api.services.update(service.id, service, params)
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateService', response.data)
                            dispatch('fetchServicesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        deleteService({commit, dispatch}, id) {//remove
            return new Promise((resolve, reject) => {
                const params = getApiProps('services')
                this.$api.services.delete(id, {...params, ...with_removed})//remove
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            if (!response.data) commit('deleteService', id)
                            else commit('updateService', response.data)
                            dispatch('fetchServicesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        restoreService({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('services')
                this.$api.services.restore(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && !response.data?.error) {
                            commit('updateService', response.data)
                            dispatch('fetchServicesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },
        deleteServicePermanently({commit, dispatch}, id) {
            return new Promise((resolve, reject) => {
                const params = getApiProps('services')
                this.$api.services.deletePermanently(id, {...params, ...with_removed})
                    .then((response) => {
                        if (response.status < 400 && (!response.data || !response.data?.error)) {
                            commit('deleteService', id)
                            dispatch('fetchServicesChanged')
                        }
                        resolve(response)
                    })
                    .catch((error) => {
                        console.error(error);
                        reject(error)
                    });
            })
        },

        //sayHello() {}
    },
    mutations: {
        setServicesLiteLoad(state, LiteLoad) {
            state.servicesLiteLoad = state.servicesLiteLoad || LiteLoad
        },
        setServicesFullLoad(state, FullLoad) {
            state.servicesFullLoad = state.servicesFullLoad || FullLoad
        },

        setServices(state, nServices) {
            nServices = nServices.map(u => {
                //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                return Object.freeze(u)
            })
            nServices.sort(sortByName)
            state.services = nServices
        },

        updateServices(state, nServices) {
            if (!state.services.length) {
                nServices = nServices.map(u => {
                    //if (u?.name) u.name_ = u.name.toLocaleLowerCase()
                    return Object.freeze(u)
                })
                nServices.sort(sortByName)
                state.services = nServices
                return true
            }

            // console.log('updateServices', state.services.length)
            const indexById = getServicesIndexMap(state)
            nServices.forEach(function (nService) {
                let i = indexById.has(nService.id) ? indexById.get(nService.id) : -1
                if (i < 0) {
                    indexById.set(nService.id, state.services.length)
                    state.services.push(Object.freeze(nService))
                } else
                if (!state.servicesFullLoad || state.services[i][changedField] != nService[changedField]) {
                    // updateObjectByDiff(state.services[i], nService)
                    delete nService.id
                    state.services[i] = Object.freeze({...state.services[i], ...nService})
                }
            })
        },
        filterServices(state, nServices) {
            // let Ids = state.services.map(u=> u.id)
            let nIds = new Set(nServices.map(u => u.id))
            state.services = state.services.filter(u => nIds.has(u.id))
        },
        updateService(state, nService) {
            let i = state.services.findIndex(u => (u.id == nService.id))
            if (i < 0) {
                state.services.push(Object.freeze(nService))
            } else
            if (!state.servicesFullLoad || state.services[i][changedField] != nService[changedField]) {
                // updateObjectByDiff(state.services[i], nService)
                let service = {...nService} //ToDo fix
                delete service.id
                state.services[i] = Object.freeze({...state.services[i], ...service})
            }
        },
        deleteService(state, id) {
            let i = state.services.findIndex(u => (u.id == id))
            if (i != -1) {
                state.services.splice(i, 1)
            }
        },
        clearServices(state) {
            state.services = []
            state.servicesLiteLoad = false
            state.servicesFullLoad = false
        },
    },
    getters: {
        isServicesLiteLoad(state) {
            return state.servicesLiteLoad
        },
        isServicesFullLoad(state) {
            return state.servicesFullLoad
        },
        getServices(state) {
            return state.services
        },
        getServicesByIds(state) {
            return state.services.reduce((servicesByIds, u) => {
                servicesByIds[u.id] = u
                return servicesByIds
            }, {})
        },
    }
}
